<template>
  <div class="partner-developers-container">
    <Breadcrumb />

    <section>
      <intersect @enter="animate = true">
        <div
          class="head-banner without-links fadeUp"
          v-if="$store.state.selected_menu"
          :class="animate ? 'animate' : ''"
        >
          <div class="img-box parallaxe">
            <picture>
              <source media="(max-width: 767px)" :srcset="_.get($store.state.current_content, 'primary.0.images.0.devices.mobile')" />
              <source media="(max-width: 1023px)" :srcset="_.get($store.state.current_content, 'primary.0.images.0.devices.tablet')" />
              <img
                :src="_.get($store.state.current_content, 'primary.0.images.0.url')"
                class="img-absolute"
                alt
                v-prlx="{ speed: 0.08 }"
              />
            </picture>
          </div>
        </div>
      </intersect>
    </section>

    <section class="container widget-content-container">
      <intersect @enter="animate = true">
        <div class="widget-content fadeUp" :class="animate ? 'animate' : ''">
          <img
            :src="
              _.get($store.state.current_content, 'primary.0.logo.0.url')
            "
            class="banner-logo"
            v-if="_.get($store.state.current_content, 'primary.0.logo')"
          />

          <div class="widget-content-text">
            <h1 class="main-title">
              {{ _.get($store.state.current_content, 'primary.0.title') }}
            </h1>

            <div class="main-teaser">
              {{ _.get($store.state.current_content, 'primary.0.teaser') }}
            </div>

            <div v-if="_.get($store.state.current_content, 'primary.0.status') && _.get($store.state.current_content, 'primary.0.status') !== 'none'" class="main-status">
              {{ $fn.tr(_.get($store.state.current_content, 'primary.0.status')) }}
            </div>
          </div>
        </div>
      </intersect>
    </section>

    <div class="container layout-outer flex-box">
      <div class="layout-left">
        <LayoutContentProjects
          v-if="$store.state.current_content"
          :itemData="$store.state.current_content"
        />
      </div>

      <intersect @enter="animate = true">
        <div v-if="windowWidth >= 1024" class="layout-right fadeUp" :class="animate ? 'animate' : ''">
          <LeadGeneratorProjects />
          
          <HowToApply
                  v-if="_.get($store.state.current_content, 'secondary.usefull_tools_right.conf.enabled')==1"
                  :itemData="_.get($store.state.current_content, 'secondary.usefull_tools_right.conf')"
          />
        </div>
      </intersect>
    </div>

    <SimilarProjects
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.SimilarDeveloperProjects.conf.enabled'
        ) == 1
      "
      :itemData="this.$store.state.current_content"
    />
  </div>
</template>

<script>
import Vue from "vue";
import Breadcrumb from "@/components/Breadcrumb";
import LayoutContentProjects from "@/components/LayoutContentProjects";
import MoneyTransferBox from "@/components/MoneyTransferBox";
import SimilarProjects from "@/components/SimilarProjects";
import HowToApply from "@/components/HowToApply";
import LeadGeneratorProjects from "@/components/LeadGeneratorProjects";
import MainMixin from "@/mixins/main";
import Intersect from "vue-intersect";
import Paralax from "@/assets/js/paralax.js";
Vue.directive("prlx", Paralax);

export default {
  mixins: [MainMixin],
  components: {
    Breadcrumb,
    LayoutContentProjects,
    MoneyTransferBox,
    SimilarProjects,
    HowToApply,
    LeadGeneratorProjects,
    Intersect,
  },
  mounted() {
    this.scroll();
  },
  methods: {},
  data() {
    return {
      animate: false,
      animate2: false,
    };
  },
  computed: {
    windowWidth() {
      return window.innerWidth
    },
  },
};
</script>
